export default "__VITE_ASSET__C8XZ0KEG__"